(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  /* Delegation also supports sections re-rendered by the Shopify editor. */
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest(
      '.collection-slider-section .collection-slide[data-scroll-target]'
    );
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var key = link.getAttribute('data-scroll-target');
    var target = document.getElementById(key);
    if (!target) {
      var sections = document.querySelectorAll('[id^="shopify-section-"]');
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].id.endsWith('__' + key)) {
          target = sections[i];
          break;
        }
      }
    }
    /* Retain the normal href when the target is absent from this page. */
    if (!target) return;
    event.preventDefault();

    var header = document.getElementById('SiteHeader');
    var offset;
    if (header && getComputedStyle(header).position === 'fixed') {
      offset = header.getBoundingClientRect().height;
    } else {
      offset = parseFloat(getComputedStyle(document.documentElement)
        .getPropertyValue('--header-sticky-height'));
      if (isNaN(offset)) offset = window.innerWidth <= 1023 ? 108 : 60;
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
